export const themeConfig = {
  initialColorMode: "dark",
  useSystemColorMode: false
}